import { StyleSheet } from "react-native";

export default StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#f8fbff",
    paddingVertical: 24,
    paddingHorizontal: 16,
    alignItems: "center",
  },
  pageTitle: {
    fontSize: 30,
    fontWeight: "800",
    color: "#111827",
    marginBottom: 8,
    textAlign: "center",
  },
  pageSubtitle: {
    fontSize: 15,
    color: "#4b5563",
    lineHeight: 22,
    maxWidth: 760,
    textAlign: "center",
    marginBottom: 20,
  },
  iosButton: {
    width: "100%",
    minHeight: 50,
    borderRadius: 16,
    marginTop: 8,
    backgroundColor: "#f8fafc",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "#d1d5db",
    paddingHorizontal: 16,
  },
  iosButtonText: {
    color: "#111827",
    fontSize: 15,
  },
  input: {
    width: "100%",
    minHeight: 52,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#d1d5db",
    backgroundColor: "#f8fafc",
    paddingHorizontal: 16,
    color: "#111827",
    fontSize: 15,
    marginBottom: 8,
  },
  helperText: {
    fontSize: 12,
    color: "#6b7280",
    lineHeight: 18,
    marginBottom: 14,
  },
  errorText: {
    color: "#b91c1c",
  },
  errorInput: {
    borderColor: "#f97316",
  },
  submitButton: {
    width: "100%",
    maxWidth: 760,
    height: 58,
    borderRadius: 18,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 8,
    shadowColor: "#0f172a",
    shadowOpacity: 0.14,
    shadowOffset: { width: 0, height: 14 },
    shadowRadius: 24,
    elevation: 4,
  },
  submitButtonText: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 16,
  },
  formError: {
    width: "100%",
    maxWidth: 760,
    color: "#b91c1c",
    fontSize: 14,
    lineHeight: 20,
    textAlign: "left",
    marginBottom: 8,
  },
});
